import React, { useEffect, useState } from 'react';
import PubSub from 'services/PubSub/';
import LoginService from 'services/Login/'
import FormLogin from './FormLogin';
import Drawer from "components/Drawers/Drawer";
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let actions = [];

const DrawerLogin = () => {

    const [settings, setSettings] = useState({successCallback: false});

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.LOGIN_OPEN, openLogin));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
        }
    },[]);

    const openLogin = (payload) => {
        const isLogged = LoginService.isLogged();

        if(!isLogged) {
            if(payload.value){
                setSettings(payload.value);
            }else{
                setSettings(null);
            }
        }
    }

    return(
        <Drawer customClass={'drawer-login-wrap'} actionOpen={actionsType.DRAWER.LOGIN_OPEN} actionClose={actionsType.DRAWER.LOGIN_CLOSE}>
            <FormLogin payload={settings}  />
        </Drawer>
    );

}
export default DrawerLogin;
